import { render, staticRenderFns } from "./rules_block.vue?vue&type=template&id=1ec1e502"
import script from "./rules_block.vue?vue&type=script&lang=js"
export * from "./rules_block.vue?vue&type=script&lang=js"
import style0 from "./rules_block.vue?vue&type=style&index=0&id=1ec1e502&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports